

export interface IWinner {
   place: number;
   name: string;
   photo: string;
   voit: number;
}

export const winnersData: IWinner[] = [
   {
      place: 1,
      name: 'Inna Mykytiuk',
      photo: '/img/cardImage/Mykytiuk/Photo_Mykytiuk_Inna.jpg',
      voit: 124
   },
   {
      place: 2,
      name: 'Evgeny Grishin',
      photo: '/img/cardImage/EvgenyGrishin/Evgeny_Grishin.png',
      voit: 52
   },
   {
      place: 3,
      name: 'Maksym Kushchenko',
      photo: '/img/cardImage/Kushchenko_Maksym/Photo.jpg',
      voit: 35
   },
];